<!-- Chrome comes from the NewSidebar flag; page nav is projected via #content (one @switch). -->
@if (newSidebar) {
  <app-new-sidebar>
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </app-new-sidebar>
} @else {
  <app-old-sidebar>
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </app-old-sidebar>
}

<ng-template #content>
  @switch (page()) {
    @case ('patients') {
      <app-patients-nav></app-patients-nav>
    }
    @case ('patexams') {
      <app-patexams-nav></app-patexams-nav>
    }
    @case ('exam') {
      <app-exam-nav></app-exam-nav>
    }
  }
</ng-template>
